import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	ElementRef,
	ViewChild,
	ViewChildren,
	QueryList,
} from "@angular/core";
import { DxScrollViewModule, DxScrollViewComponent } from "devextreme-angular";
import { ApplicationModel } from "app/core/models/application.model";
import { BaseView } from "app/core/views/base-view";
import { PresentationModePopupComponent } from "app/core/views/presentation-mode-popup/presentation-mode-popup.component";
import { KeyPressConstants } from "app/core/vo/app-constants";
@Component({
	selector: "app-dropdown",
	templateUrl: "./dropdown.directive.html",
	styleUrls: ["./dropdown.directive.css"],
	host: {
		"(document:click)": "onWindowClick($event)",
	},
})
export class DropdownDirective extends BaseView implements OnInit, OnChanges {
	@Input()
	DropDownList: Array<any>;
	@Input()
	label?: string;
	@Input()
	labelIcon?: string;
	@Input()
	labelColor?: string;
	@Input()
	labelIconPos?: string;
	@Input()
	optionsPos?: string;
	@Input()
	showCaret?: Boolean;
	@Input()
	showLabel?: Boolean;
	@Input()
	txtDirection?: string;
	public myDropdownHeight: any;

	@Output() optionSelected: EventEmitter<any> = new EventEmitter<any>();
	public isDDOpen: Boolean;

	@ViewChild("dropDown", { static: true }) dropDown;
	constructor(private _eref: ElementRef) {
		super();
		this.isDDOpen = false;
	}
	public currentIndex = -1;
	public selectedIndex: number = null;
	@ViewChild("dropDownBtn", { static: true }) dropDownBtn;
	@ViewChildren("dropdownItem") dropdownItems: QueryList<ElementRef>;
	ngOnInit() {}
	ngOnChanges(change) {
		//console.log("change ",change);
	}
	
	optionClickHandler(option,event,index: number) {
		event.preventDefault();
		this.isDDOpen = false;
		this.optionSelected.emit(option);
		this.selectedIndex = index;
	}
	dropDownButtonClickHandler() {
		this.isDDOpen = this.isDDOpen ? false : true;
		if (/MSIE \d|Trident.*rv:/i.test(navigator.userAgent)) {
			setTimeout(() => {
				let arr = this._eref.nativeElement.querySelectorAll(
					".dropdown-content-ie"
				);
				console.log("AK", arr[0].clientHeight);
				this.myDropdownHeight = arr[0].clientHeight;
			}, 100);
		}
	}
	onWindowClick(event) {
		if (!this._eref.nativeElement.contains(event.target)) {
			// or some similar check
			this.isDDOpen = false;
		}
	}

	public accessDropdown(event, fromBtn: boolean) {
		if (
				event.key === KeyPressConstants.ARROWDOWN ||
				event.key === KeyPressConstants.ARROWUP
			) {
			event.preventDefault();
		}
		this.navigateDropdown(
			event,
			fromBtn,
			this.isDDOpen,
			this.dropDownBtn,
			this.dropdownItems,
			this.DropDownList,
			null
		);
		this.isDDOpen = this.getShowDropdown();
	}
	/*
    // console.log("this._eref.nativeElement  :",this._eref.nativeElement);
   // console.log("event.target  :",event.target);
   // console.log("this._eref.nativeElement.contains(event.target) :",this._eref.nativeElement.contains(event.target));
    if (!event.target.matches('.dropbtn')) {
         this.isDDOpen = false;
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }*/
}
